import React, { useState, useEffect, useRef } from "react";
import addIcon from "../../assets/images/DeathModuleNew/addIcon.png";
import lockIcon from "../../assets/images/DeathModuleNew/Feature.png";
import profileIcon from "../../assets/images/chats/profile-icon.png";
import downloadIcon from "../../assets/SVGs/message-circle-down.svg";
import sendIcon from "../../assets/images/chats/send-icon-2.svg";
import { InviteChatModal } from "./chatComponents/InviteChatModal";
import { ChatInviteAccept } from "./chatComponents/ChatInviteAccept";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import logo from "../../assets/images/logoForPlaid.png";
import { useDispatch, useSelector } from "react-redux";
import { setUserOnline } from "../../redux/slices/loginSlice";
import {
  setOnlineUserStatus,
  setAccpetedUsers,
  setOnlineUsersList,
  setPendingUsersList,
  setTypingUsersList,
  setToastMessage,
  setMessagesList,
  setMessagesTime,
  setShowToaster,
  setLatestConversationsList,
  setUnseenMessages,
} from "../../redux/slices/chatSlice";
import DASHBOARD_API from "../../apis/dashboard.api";
import { Icon, Spin } from "antd";
import swal from "sweetalert";
import moment from "moment";
import "./styles/chatSystem.css";
import { getWs } from "../../utils/websocketConnect";
import { ChatUserSkeleton } from "../Skeletons/ChatUserSkeleton";
import { ChatWindowSkeleton } from "../Skeletons/ChatWindowSkeleton";
import { highlightFlaggedWords } from "../../helpers/highlightHelper";
import { ChatDownloadModal } from "./chatComponents/ChatDownloadModal";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
import { T } from "antd/lib/upload/utils";

export const ChatSystemMain = () => {
  const [users, setUsers] = useState([]);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [userStatus, setUserStatus] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState("");
  const [typingUsers, setTypingUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalChats, setTotalChats] = useState(0);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [openInviteModal, setOpenInviteModal] = useState(false);
  const isUserOnline = useSelector(
    (state) => state.rootReducer.chatInfo.onlineUserStatus
  );
  const toasterMessage = useSelector(
    (state) => state.rootReducer.chatInfo.toastMessage
  );
  const showToaster = useSelector(
    (state) => state.rootReducer.chatInfo.showToaster
  );
  const messagesList = useSelector(
    (state) => state.rootReducer.chatInfo.messagesList
  );
  const onlineUsersList = useSelector(
    (state) => state.rootReducer.chatInfo.onlineUsersList
  );
  const typingUsersList = useSelector(
    (state) => state.rootReducer.chatInfo.typingUsersList
  );
  const pendingUsersList = useSelector(
    (state) => state.rootReducer.chatInfo.pendingUsersList
  );
  const accpetedUsersLsit = useSelector(
    (state) => state.rootReducer.chatInfo.accpetedUsersList
  );
  const latestConversationsList = useSelector(
    (state) => state.rootReducer.chatInfo.latestConversationsList
  );
  const unseenMessagesList = useSelector(
    (state) => state.rootReducer.chatInfo.unseenMessages
  );
  const messagesTime = useSelector(
    (state) => state.rootReducer.chatInfo.messagesTime
  );
  // console.log(
  //   "isUserOnline",
  //   isUserOnline,
  //   messagesList,
  //   onlineUsersList,
  //   typingUsersList,
  //   pendingUsersList,
  //   accpetedUsersLsit
  // );
  const dispatch = useDispatch();

  useEffect(() => {
    setMessages(messagesList);
  }, [messagesList]);

  useEffect(() => {
    setOnlineUsers(onlineUsersList);
  }, [onlineUsersList]);

  useEffect(() => {
    setTypingUsers(typingUsersList);
  }, [typingUsersList]);

  useEffect(() => {
    setPendingUsers(pendingUsersList);
  }, [pendingUsersList]);

  useEffect(() => {
    setUsers(accpetedUsersLsit);
  }, [accpetedUsersLsit]);

  useEffect(() => {
    setLatestConversation(latestConversationsList);
  }, [latestConversationsList]);
  // const ws = useRef(null);
  const chatMessagesRef = useRef(null);
  const scrollToBottom = () => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTo({
        top: chatMessagesRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };
  const ws = getWs();

  //  useEffect(() => {
  //     const token = localStorage.getItem("userLoginToken");
  //     const WEB_SOCKETS_URL =
  //       "wss://ff87jjbzt6.execute-api.us-east-1.amazonaws.com/Prod";
  //     console.log(`${WEB_SOCKETS_URL}?authorization=${token}`);
  //     ws.current = new WebSocket(`${WEB_SOCKETS_URL}?authorization=${token}`);

  //     if (ws.current && ws.current.readyState === WebSocket.OPEN) {
  //       ws.current.send(JSON.stringify({"action":"typing","conversationId":2111}));
  //     }

  //     ws.current.onerror = (error) => {
  //       console.error("WebSocket error:", error);
  //     };

  //     // Cleanup on unmount
  //     return () => {
  //       if (ws.current) {
  //         ws.current.close();
  //       }
  //     };
  //   }, []);
  const sendUserTypingEvent = () => {
    if (ws.readyState === WebSocket.OPEN) {
      console.log("sending action typing");
      ws.send(
        JSON.stringify({
          action: "typing",
          conversationId: selectedUser.id,
          typing: true,
        })
      );
    }
  };
  const sendMsgDelivered = (ids) => {
    // const ws = getWs();
    if (ws.readyState === WebSocket.OPEN) {
      console.log("sending action delivered", ids);
      ws.send(
        JSON.stringify({
          action: "delivered",
          ids: ids,
        })
      );
    }
  };
  const sendMsgRead = (ids) => {
    // const ws = getWs();
    if (ws.readyState === WebSocket.OPEN) {
      console.log("sending action read", ids);
      ws.send(
        JSON.stringify({
          action: "read",
          ids: ids,
        })
      );
    }
  };
  const stopUserTyping = () => {
    // const ws = getWs();
    if (ws.readyState === WebSocket.OPEN) {
      console.log("sending action typing");
      ws.send(
        JSON.stringify({
          action: "typing",
          conversationId: selectedUser.id,
          typing: false,
        })
      );
    }
  };
  const handleStopUserTyping = () => {
    // stopUserTyping();
    setTimeout(() => {
      stopUserTyping();
    }, 2000); // Hide after 2 seconds
  };
  const [userList, setUserList] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [conversationloading, setConversationLoading] = useState(false);
  const [chatWindowLoading, setChatWindowLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [latestConversation, setLatestConversation] = useState([]);

  // const filteredChats =
  //   users &&
  //   users
  //     .filter(
  //       (user) =>
  //         user.name &&
  //         user.name.toLowerCase().includes(searchQuery.toLowerCase())
  //     )
  //     .sort((a, b) => {
  //       if (Array.isArray(messagesTime) && messagesTime.length > 0) {
  //         // Get latest conversation for `a` and `b`
  //         const latestA = messagesTime.find(
  //           (conv) => conv.conversationId === a.id
  //         );
  //         const latestB = messagesTime.find(
  //           (conv) => conv.conversationId === b.id
  //         );
  //       console.log("here in test",messagesTime,latestA,latestB,a.id,b.id)
  //         // Extract updated dates from chat histories or fallback to `updatedAt`
  //         const updatedA =
  //           (a.chatHistories &&
  //             a.chatHistories[0] &&
  //             a.chatHistories[0].createdAt) ||
  //           a.updatedAt ||
  //           0;
  //         const updatedB =
  //           (b.chatHistories &&
  //             b.chatHistories[0] &&
  //             b.chatHistories[0].createdAt) ||
  //           b.updatedAt ||
  //           0;

  //         // Check presence in `latestConversation`
  //         const isAInLatest = latestA ? 1 : 0;
  //         const isBInLatest = latestB ? 1 : 0;

  //         // Sort by presence first
  //         if (isBInLatest !== isAInLatest) {
  //           return isBInLatest - isAInLatest;
  //         }

  //         // If both are present, sort by `updatedAt`
  //         if (updatedA && updatedB) {
  //           return new Date(updatedB).getTime() - new Date(updatedA).getTime();
  //         }

  //         // If only one is present, sort it higher
  //         return updatedB ? 1 : -1;
  //       }
  //       return 0; // If no latestConversation, maintain original order
  //     });

  const filteredChats =
    users &&
    users
      .filter(
        (user) =>
          user.name &&
          user.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .sort((a, b) => {
        const latestA =
          messagesTime &&
          messagesTime.find((conv) => conv.conversationId === a.id);
        const latestB =
          messagesTime &&
          messagesTime.find((conv) => conv.conversationId === b.id);

        const updatedA =
          (latestA && latestA.updatedAt) ||
          (a.chatHistories &&
            a.chatHistories[0] &&
            a.chatHistories[0].createdAt) ||
          a.updatedAt ||
          0;
        const updatedB =
          (latestB && latestB.updatedAt) ||
          (b.chatHistories &&
            b.chatHistories[0] &&
            b.chatHistories[0].createdAt) ||
          b.updatedAt ||
          0;

        // Sort by updated time if both are present
        return new Date(updatedB).getTime() - new Date(updatedA).getTime();
      });
  // Scroll to the bottom when the selected user changes
  useEffect(() => {
    scrollToBottom();
  }, [selectedUser]);

  // Scroll to the bottom when new messages are added
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    getAll();
  }, []);

  const getAll = async () => {
    setUserStatus(true);
    await getUsersList();
    await getChatUsers();
    await getPendingChatUsers();
  };
  const getBothUsers = async () => {
    await getChatUsers();
    await getPendingChatUsers();
  };
  const Toast = ({ message, onClose }) => {
    return (
      <div className="toast">
        <button>
          <Icon
            type="info-circle"
            style={{ fontSize: "14px", color: "#09A84D", fontWeight: "700" }}
            theme="filled"
          ></Icon>
        </button>
        <p style={{ color: "black", marginBottom: "0px", lineHeight: "1.4" }}>
          {message}
        </p>
        <button onClick={onClose}>
          <Icon
            type="close"
            style={{ fontSize: "14px", color: "gray", fontWeight: "700" }}
          ></Icon>
        </button>
      </div>
    );
  };
  const [showToast, setShowToast] = useState(false);
  const [showToastMessage, setShowToastMessage] = useState(null);

  // const handleShowToast = () => {
  //   setShowToast(true);
  //   setTimeout(() => {
  //     setShowToast(false);
  //   }, 3000); // Hide after 3 seconds
  // };
  const getChatUsers = async () => {
    try {
      setLoading(true);
      setConversationLoading(true);
      const data = await DASHBOARD_API.fetchChatUserList("accepted");
      setUsers([]);
      dispatch(setAccpetedUsers([]));
      if (data && data.users) {
        // const updatedUsers = data.users.map((user) => ({
        //   ...user,
        //   name: user.ReceiverUser ? user.ReceiverUser.name : "", // Generate a username based on user ID or any other logic
        // }));
        const updatedUsers = data.users.map((user) => ({
          ...user,
          image:
            user.ReceiverUser && user.ReceiverUser.id !== currentUser.id
              ? user.ReceiverUser.image // Use ReceiverUser's name if currentUser.id does not match receiverId
              : user.SenderUser && user.SenderUser.id !== currentUser.id
              ? user.SenderUser.image // Use SenderUser's name if currentUser.id does not match senderId
              : "",
          name:
            user.ReceiverUser && user.ReceiverUser.id !== currentUser.id
              ? user.ReceiverUser.name // Use ReceiverUser's name if currentUser.id does not match receiverId
              : user.SenderUser && user.SenderUser.id !== currentUser.id
              ? user.SenderUser.name // Use SenderUser's name if currentUser.id does not match senderId
              : "",
          userLastSeen:
            user.ReceiverUser && user.ReceiverUser.id !== currentUser.id
              ? user.receiverLastSeen // Use ReceiverUser's name if currentUser.id does not match receiverId
              : user.SenderUser && user.SenderUser.id !== currentUser.id
              ? user.senderLastSeen // Use SenderUser's name if currentUser.id does not match senderId
              : "",
          userOnlineId:
            user.ReceiverUser && user.ReceiverUser.id !== currentUser.id
              ? user.ReceiverUser.id // Use ReceiverUser's name if currentUser.id does not match receiverId
              : user.SenderUser && user.SenderUser.id !== currentUser.id
              ? user.SenderUser.id // Use SenderUser's name if currentUser.id does not match senderId
              : "",
        }));
        setUsers(updatedUsers);
        dispatch(setAccpetedUsers(updatedUsers)); // Add new user to accepted users
        const onlineUserIds = data.users
          .filter((user) => user.isOnline)
          .map((user) =>
            user.ReceiverUser && user.ReceiverUser.id !== currentUser.id
              ? user.ReceiverUser.id
              : user.SenderUser && user.SenderUser.id !== currentUser.id
              ? user.SenderUser.id
              : null
          )
          .filter((id) => id !== null);
        setOnlineUsers((prevOnlineUsers) => [
          ...prevOnlineUsers,
          ...onlineUserIds,
        ]);
        dispatch(setOnlineUsersList([...onlineUsers, ...onlineUserIds])); // Add new user to accepted users
      }
      setLoading(false);
      setConversationLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setConversationLoading(false);
    }
  };

  const getPendingChatUsers = async () => {
    try {
      setLoading(true);
      const data = await DASHBOARD_API.fetchChatUserList("pending");
      // setUsers([]);
      setPendingUsers([]);
      dispatch(setPendingUsersList([])); // Update pending users in Redux
      if (data && data.users) {
        const updatedUsers = data.users
          // .filter((user) => user.senderId !== currentUser.id) // Exclude the current user
          .map((user) => ({
            ...user,
            name: user.SenderUser ? user.SenderUser.name : "", // Generate a username based on user ID or any other logic
            image:
              user.ReceiverUser && user.ReceiverUser.id !== currentUser.id
                ? user.ReceiverUser.image // Use ReceiverUser's name if currentUser.id does not match receiverId
                : user.SenderUser && user.SenderUser.id !== currentUser.id
                ? user.SenderUser.image // Use SenderUser's name if currentUser.id does not match senderId
                : "",
          }));
        setPendingUsers(updatedUsers);
        dispatch(setPendingUsersList(updatedUsers)); // Update pending users in Redux
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getUsersList = async () => {
    try {
      setLoading(true);
      setConversationLoading(true);

      const data = await DASHBOARD_API.fetchUserList();
      setUserList([]);
      if (data && data.data) {
        const filteredUsers = data.data.filter(
          (user) => user.id !== currentUser.id
        );
        setUserList(filteredUsers);
        setAllUsers(data.data);
      }
      setLoading(false);
      setConversationLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setConversationLoading(false);
    }
  };
  const currentUser =
    localStorage.getItem("userData") != "undefined" &&
    JSON.parse(localStorage.getItem("userData") || null);

  const getChatHistory = async (id, page) => {
    try {
      setLoading(true);
      setChatWindowLoading(true);
      const data = await DASHBOARD_API.fetchChatHistory(id, page);
      if (data && data.data && data.data.rows) {
        // setMessages((prevMessages) => [...prevMessages, ...data.data.rows]);
        // dispatch(setMessagesList([...messagesList, ...data.data.rows]));
        const sortedMessages = [...data.data.rows].sort((a, b) => a.id - b.id);
        console.log(
          "total messages",
          [...messages, ...data.data.rows],
          sortedMessages
        );
        if (page === 1) {
          setMessages(sortedMessages);
          dispatch(setMessagesList(sortedMessages));
        } else {
          setMessages((prevMessages) => [...sortedMessages, ...prevMessages]);
          dispatch(setMessagesList([...sortedMessages, ...messagesList]));
        }
        setTotalChats(data.data.count); // Assuming total number of chats is in `data.data.total`
        // Get the IDs of messages where status is "SENT"
        const sentChats = data.data.rows
          .filter(
            (message) =>
              message.status === "SENT" && message.senderId !== currentUser.id
          )
          .map((message) => message.id);
        const deliveredChats = data.data.rows
          .filter(
            (message) =>
              message.status === "DELIVERED" &&
              message.senderId !== currentUser.id
          )
          .map((message) => message.id);
        // console.log("alllllll", [...sentChats, ...deliveredChats]);
        if (deliveredChats) {
          sendMsgDelivered(sentChats);
        }
        // Get the IDs of messages where status is "DELIVERED"
        if (sentChats) {
          sendMsgRead([...sentChats, ...deliveredChats]);
        }
      }
      setLoading(false);
      setChatWindowLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setChatWindowLoading(false);
    }
  };

  useEffect(() => {
    if (selectedUser && selectedUser.id) {
      if (page !== 1) {
        getChatHistory(selectedUser && selectedUser.id, page);
      }
    }
  }, [page]);

  const handleScroll = () => {
    if (
      chatMessagesRef.current.scrollTop === 0 &&
      !loading &&
      messages.length < totalChats
    ) {
      if (messages.length < totalChats) {
        setPage((prevPage) => prevPage + 1);
      }
    }
  };

  useEffect(() => {
    const chatRef = chatMessagesRef.current;
    if (chatRef) {
      chatRef.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (chatRef) {
        chatRef.removeEventListener("scroll", handleScroll);
      }
    };
  }, [messages, totalChats, loading]);

  const handleInvite = async (user) => {
    try {
      swal({
        title: "Are you sure?",
        text: `Do you want to send an invite to ${user.name || "this user"}?`,
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then(async (willSend) => {
        if (willSend) {
          setLoading(true);
          handleCloseInviteModal();
          let payload = { id: user.id };

          const response = await DASHBOARD_API.chatInvite(payload);

          if (response && response.status === 200) {
            swal("Success", response.message, "success");
            await getBothUsers();
          } else if (response && response.status === 400) {
            swal("Error", response.message, "error");
          }
          setLoading(false);
        } else {
          swal("Cancelled", "Invite was not sent.", "info");
        }
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleAcceptInvite = async (user) => {
    swal({
      title: "Are you sure?",
      text: `Do you want to accept the invite from ${
        user.name || "this user"
      }?`,
      icon: "warning",
      buttons: ["Cancel", "Yes, Accept"],
      dangerMode: false,
    }).then(async (willAccept) => {
      if (willAccept) {
        try {
          setLoading(true);
          let payload = {
            conversationId: +user.id,
          };
          let acceptedUser = {
            ...user,
            conversationId: +user.id,
            userOnlineId:
              user.receiverId && user.receiverId !== currentUser.id
                ? user.receiverId
                : user.senderId && user.senderId !== currentUser.id
                ? user.senderId
                : "",
            invitationStatus: "ACCEPTED",
          };
          const response = await DASHBOARD_API.acceptChatInvite(payload);
          if (response && response.status === 200) {
            swal("Success", response.message, "success");
            await getBothUsers();
            setMessages([]);
            dispatch(setMessagesList([]));
            setSelectedUser(acceptedUser);
            dispatch(setAccpetedUsers([...users, acceptedUser]));
            setSelectedIndex(0);
          }
          if (response && response.status === 400) {
            swal("Error", response.message, "error");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      }
    });
  };
  const handleDeclineInvite = async (user) => {
    swal({
      title: "Are you sure?",
      text: `Do you want to decline the invite from ${
        user.name || "this user"
      }?`,
      icon: "warning",
      buttons: ["Cancel", "Yes, Decline"],
      dangerMode: true,
    }).then(async (willDecline) => {
      if (willDecline) {
        try {
          setLoading(true);
          let payload = {
            conversationId: +user.id,
          };

          const response = await DASHBOARD_API.declineChatInvite(payload);
          if (response && response.status === 200) {
            swal("Success", response.message, "success");
            await getBothUsers();
            setMessages([]);
            dispatch(setMessagesList([]));
          }
          if (response && response.status === 400) {
            swal("Error", response.message, "error");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      }
    });
  };
  const handleCancelInvite = async (user) => {
    const isSender = user.senderId === currentUser.id;
    // if I am sender -> show receiver’s info, else show sender’s info
    const displayUser = isSender ? user.ReceiverUser : user.SenderUser;

    swal({
      title: "Are you sure?",
      text: `Do you want to cancel the invite to ${
        displayUser.name || "this user"
      }?`,
      icon: "warning",
      buttons: ["No, Keep", "Yes, Cancel"],
      dangerMode: true,
    }).then(async (willCancel) => {
      if (willCancel) {
        try {
          setLoading(true);
          let payload = {
            conversationId: +user.id,
          };

          const response = await DASHBOARD_API.cancelChatInvite(payload);
          if (response && response.status === 200) {
            swal("Success", response.message, "success");
            await getBothUsers();
            setMessages([]);
            dispatch(setMessagesList([]));
          }
          if (response && response.status === 400) {
            swal("Error", response.message, "error");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      }
    });
  };

  const handleChatClick = (user) => {
    setMessages([]);
    const updatedConversations = latestConversationsList.filter(
      (conversation) => conversation.conversationId !== user.id
    );
    const matchingConversations =
      latestConversationsList &&
      latestConversationsList.filter((conv) => conv.conversationId === user.id);
    const latestMatchingConv =
      matchingConversations &&
      matchingConversations.sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt) // Assuming `timestamp` exists
      )[0];
    let lastMessage = null;
    if (latestMatchingConv) {
      lastMessage = {
        chatHistories: [
          {
            id: latestMatchingConv.id,
            message: latestMatchingConv.message,
            createdAt: latestMatchingConv.updatedAt,
          },
        ],
      };
    }
    const updatedUsers =
      users &&
      users.map((item) => {
        if (item.id === user.id) {
          return {
            ...item,
            unreadCount: 0,
            chatHistories: lastMessage
              ? lastMessage.chatHistories
              : item.chatHistories,
          }; // Set unreadCount to 0 for the matched user
        }
        return item; // Keep the other conversations unchanged
      });
    const updatedUnseenMsg = unseenMessagesList.filter(
      (conversation) => conversation.conversationId !== user.id
    );
    console.log("updatedUnseenMsg", updatedUnseenMsg);
    setUsers(updatedUsers);
    dispatch(setLatestConversationsList(updatedConversations));
    dispatch(setUnseenMessages(updatedUnseenMsg));

    dispatch(setMessagesList([]));
    setSelectedUser(user);
    setPage(1);
    setTotalChats(0);
    getChatHistory(user.id, 1);
  };
  const getTotalUnreadMessages = (user) => {
    const unseenMessagesCount = Array.isArray(unseenMessagesList)
      ? unseenMessagesList.filter(
          (convo) => convo.conversationId === user.id && convo.status === "SENT"
        ).length
      : 0;
    return (user.unreadCount ? user.unreadCount : 0) + unseenMessagesCount;
  };
  const truncateMessage = (text, limit = 12) => {
  if (!text) return "";
  return text.length > limit ? text.substring(0, limit) + "..." : text;
};
  // const connectAgain = () => {
  //   const token = localStorage.getItem("userLoginToken");
  //   const WEB_SOCKETS_URL =
  //     "wss://ff87jjbzt6.execute-api.us-east-1.amazonaws.com/Prod";
  //   // console.log(`${WEB_SOCKETS_URL}?authorization=${token}`);
  //   ws.current = new WebSocket(`${WEB_SOCKETS_URL}?authorization=${token}`);

  //   ws.current.onopen = () => {
  //     console.log("Connected to WebSocket server");
  //     dispatch(setUserOnline(true));
  //     setUserStatus(true);
  //   };
  // };
  const allUsersRef = useRef(allUsers);
  useEffect(() => {
    allUsersRef.current = allUsers; // Keep the ref updated
  }, [allUsers]);
  // useEffect(() => {
  //   const token = localStorage.getItem("userLoginToken");
  //   const WEB_SOCKETS_URL =
  //     "wss://ff87jjbzt6.execute-api.us-east-1.amazonaws.com/Prod";
  //   console.log(`${WEB_SOCKETS_URL}?authorization=${token}`);
  //   ws.current = new WebSocket(`${WEB_SOCKETS_URL}?authorization=${token}`);
  //   console.log("isUserOnline", isUserOnline);
  //   if (!isUserOnline) {
  //     ws.current.onopen = () => {
  //       console.log("Connected to WebSocket server");
  //       dispatch(setUserOnline(true));
  //       setUserStatus(true);
  //     };
  //   }

  //   ws.current.onmessage = (event) => {
  //     const data = JSON.parse(event.data);
  //     console.log("onmessage event.data", data);
  //     if (data.action === "INVITED") {
  //       const parsedUser = JSON.parse(data.message);
  //       const findUser =
  //         allUsersRef.current &&
  //         allUsersRef.current.find((user) => user.id === +parsedUser.senderId);
  //       // console.log("findUser", findUser, allUsers);

  //       setShowToastMessage(
  //         `${findUser ? findUser.name : "Someone"} Invited You`
  //       );
  //       handleShowToast();
  //       const newUser = {
  //         ...parsedUser,
  //         // id: parsedUser.senderId,
  //         name: findUser ? findUser.name : "",
  //       };

  //       setPendingUsers((prevPendingUsers) => [...prevPendingUsers, newUser]);
  //     }
  //     if (data.action === "INVITE_ACCEPTED") {
  //       const parsedUser = JSON.parse(data.message);
  //       const acceptedUserId = parsedUser.receiverId || parsedUser.senderId;
  //       const findUser =
  //         allUsersRef.current &&
  //         allUsersRef.current.find((user) => user.id === +acceptedUserId);
  //       // console.log("findUser", findUser, allUsers);
  //       setShowToastMessage(
  //         `${findUser ? findUser.name : "Someone"} Accepted Your Invite`
  //       );
  //       handleShowToast();

  //       setPendingUsers((prevPendingUsers) =>
  //         prevPendingUsers.filter((user) => user.id !== acceptedUserId)
  //       );

  //       const newUser = {
  //         ...parsedUser,
  //         // id: acceptedUserId,
  //         name: findUser ? findUser.name : "",
  //       };

  //       setUsers((prevUsers) => [...prevUsers, newUser]);
  //     }
  //     if (data.action === "USER_ONLINE") {
  //       const parsedMessage = JSON.parse(data.message);
  //       const userId = parsedMessage.userId;
  //       setOnlineUsers((prevOnlineUsers) => [...prevOnlineUsers, userId]);
  //     }
  //     if (data.action === "USER_OFFLINE") {
  //       const parsedMessage = JSON.parse(data.message);
  //       const userId = parsedMessage.userId;
  //       console.log("userId", userId, onlineUsers);

  //       setOnlineUsers((prevOnlineUsers) =>
  //         prevOnlineUsers.filter((onlineUserId) => onlineUserId !== userId)
  //       );
  //     }
  //     if (data.action === "USER_TYPING") {
  //       const parsedTyping =
  //         typeof data.conversation === "string"
  //           ? JSON.parse(data.conversation)
  //           : data.conversation;
  //       const newTypingUser = {
  //         ...parsedTyping,
  //         userId: data ? data.userId : "",
  //       };
  //       setTypingUsers((prevTypingUsers) => [
  //         ...prevTypingUsers,
  //         newTypingUser,
  //       ]);
  //     }
  //     if (data.action === "MESSAGE") {
  //       // Add the new message to the chat
  //       const parsedMessage = JSON.parse(data.conversation);
  //       let conversation = {
  //         ...parsedMessage.conversation,
  //         message: parsedMessage.message.message,
  //       };
  //       console.log("conversationlatest", conversation);
  //       setLatestConversation(conversation);
  //       let chatMessage = {
  //         message: parsedMessage.message.message,
  //         receiver_id: currentUser.id,
  //         conversationId: parsedMessage.conversation.id,
  //         sender_id: parsedMessage.message.senderId,
  //       };
  //       setMessages((prevMessages) => [...prevMessages, chatMessage]);
  //     }
  //   };

  //   ws.current.onclose = () => {
  //     console.log("WebSocket connection closed");
  //     setUserStatus(false);
  //     dispatch(setUserOnline(false));
  //     setTimeout(function () {
  //       connectAgain();
  //     }, 1000);
  //   };

  //   ws.current.onerror = (error) => {
  //     console.error("WebSocket error:", error);
  //   };

  //   // Cleanup on unmount
  //   return () => {
  //     if (ws.current) {
  //       ws.current.close();
  //     }
  //   };
  // }, []);

  const sendMessage = async () => {
    if (messageText.trim() === "") return;
    const randomId = Math.random().toString(36).substr(2, 9);
    const newMessage = {
      // receiverId: id,
      uuid: randomId,
      message: messageText,
      conversationId: selectedUser.id,
    };
    const newMessageSent = {
      senderId: currentUser.id,
      id: randomId,
      uuid: randomId,
      message: messageText,
      conversationId: selectedUser.id,
      updatedAt: moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      status: "SENDING",
    };
    setMessages((prevMessages) => [...prevMessages, newMessageSent]);
    dispatch(setMessagesList([...messagesList, newMessageSent]));
    setLatestConversation((prev) => [...prev, newMessageSent]);
    dispatch(
      setMessagesTime(
        messagesTime &&
          messagesTime
            .map((message) =>
              message.conversationId === newMessageSent.conversationId
                ? { ...message, updatedAt: newMessageSent.updatedAt }
                : message
            )
            .concat(
              messagesTime.some(
                (message) =>
                  message.conversationId === newMessageSent.conversationId
              )
                ? []
                : {
                    conversationId: newMessageSent.conversationId,
                    updatedAt: newMessageSent.updatedAt,
                  }
            )
      )
    );
    // setLatestConversation(newMessageSent);
    stopUserTyping();
    setMessageText("");

    try {
      setSendLoading(true);
      sendMsgEvent(newMessage);
      // const resposnse = await DASHBOARD_API.chatWithUser(newMessage);
      // if (resposnse && resposnse.status === 200) {
      //   const newMessageSentAfter = {
      //     senderId: currentUser.id,
      //     id: resposnse.data.id,
      //     message: resposnse.data.message,
      //     conversationId: resposnse.data.conversationId,
      //     updatedAt: resposnse.data.sentTime,
      //     status: resposnse.data.status,
      //   };
      //   // Update local state with the updated message
      //   setMessages((prevMessages) =>
      //     prevMessages.map((msg) =>
      //       msg.id === newMessageSent.id ? newMessageSentAfter : msg
      //     )
      //   );
      //   const updatedMessagesList = messagesList.map((msg) =>
      //     msg.id === newMessageSent.id ? newMessageSentAfter : msg
      //   );
      //   // dispatch(setMessagesList(updatedMessagesList));
      //   setLatestConversation((prev) =>
      //     prev.map((msg) =>
      //       msg.id === newMessageSent.id ? newMessageSentAfter : msg
      //     )
      //   );
      //   dispatch(
      //     setLatestConversationsList([
      //       ...latestConversation,
      //       newMessageSentAfter,
      //     ])
      //   );
      //   let arr = [...messagesList, newMessageSent];
      //   const messageExists =
      //     arr && arr.some((msg) => msg.id === newMessageSent.id);
      //   console.log(
      //     "messageExists send",resposnse.data,
      //     arr,
      //     [...messages,newMessageSent],
      //     messageExists,
      //   );
      //   if (messageExists) {
      //     const updatedMessages =
      //       arr &&
      //       arr.map((msg) =>
      //         msg.id === newMessageSent.id ? newMessageSentAfter : msg
      //       );
      //     dispatch(setMessagesList(updatedMessages));
      //   }
      //   // swal("Success", resposnse.message, "success");
      // }
      setSendLoading(false);
    } catch (error) {
      console.log(error);
      setSendLoading(false);
    }

    // Send message to WebSocket server
    // if (ws.current && ws.current.readyState === WebSocket.OPEN) {
    //   ws.current.send(JSON.stringify({ type: "message", ...newMessage }));
    // }

    // Update local state
  };

  const sendMsgEvent = (payload) => {
    // const ws = getWs();
    if (ws.readyState === WebSocket.OPEN) {
      console.log("sending action message sent", payload);

      ws.send(
        JSON.stringify({
          action: "message",
          ...payload,
        })
      );
    }
  };

  const typingTimeout = useRef(null);
  const typingSent = useRef(false);
  const sendUserIsTyping = async () => {
    try {
      const resposnse = await DASHBOARD_API.sendUserTyping(selectedUser.id);
    } catch (error) {
      console.log(error);
      // setSendLoading(false);
    }
  };
  const handleCloseInviteModal = () => {
    setOpenInviteModal(false);
  };
  // console.log("onmessage ", onlineUsers);

  const processedMessagesRef = useRef(new Set());
  // useEffect(() => {
  //   if (selectedUser) {
  //     const deliveredMessages =
  //       messagesList &&
  //       messagesList
  //         .filter(
  //           (msg) =>
  //             msg.conversationId === selectedUser.id &&
  //             msg.senderId !== currentUser.id &&
  //             msg.status === "DELIVERED"
  //         )
  //         .map((msg) => msg.id);
  //     const sentMessages =
  //       messagesList &&
  //       messagesList
  //         .filter(
  //           (msg) =>
  //             msg.conversationId === selectedUser.id &&
  //             msg.senderId !== currentUser.id &&
  //             msg.status === "SENT"
  //         )
  //         .map((msg) => msg.id);
  //     // if(sentMessages && sentMessages.length > 0){

  //     // }
  //     let newArr = [...sentMessages, ...deliveredMessages];
  //     const unprocessedMessages = newArr.filter(
  //       (id) => !processedMessagesRef.current.has(id)
  //     );
  //     if (unprocessedMessages.length > 0) {
  //       // console.log(
  //       //   "deliveredMessages",
  //       //   newArr,
  //       //   sentMessages,
  //       //   deliveredMessages,
  //       //   unprocessedMessages
  //       // );
  //       const unseenMessagesUpdate = unseenMessagesList.map((msg) =>
  //         sentMessages.includes(msg.id)
  //           ? {
  //               ...msg,
  //               status: "DELIVERED",
  //             }
  //           : msg
  //       );
  //       dispatch(setUnseenMessages(unseenMessagesUpdate));
  //       sendMsgRead(unprocessedMessages);
  //       // const updatedMessages = messagesList.map((msg) =>
  //       //   deliveredMessages.includes(msg.id)
  //       //     ? { ...msg, status: "READ" }
  //       //     : msg
  //       // );

  //       // // Update state or Redux store
  //       // dispatch(setMessagesList(updatedMessages));
  //       newArr = [];
  //       unprocessedMessages.forEach((id) =>
  //         processedMessagesRef.current.add(id)
  //       );
  //     }
  //   }
  // }, [messagesList, selectedUser]);

  const sendReadEvent = () => {
    if (selectedUser) {
      const deliveredMessages =
        messagesList &&
        messagesList
          .filter(
            (msg) =>
              msg.conversationId === selectedUser.id &&
              msg.senderId !== currentUser.id &&
              msg.status === "DELIVERED"
          )
          .map((msg) => msg.id);
      const sentMessages =
        messagesList &&
        messagesList
          .filter(
            (msg) =>
              msg.conversationId === selectedUser.id &&
              msg.senderId !== currentUser.id &&
              msg.status === "SENT"
          )
          .map((msg) => msg.id);
      let newArr = [...sentMessages, ...deliveredMessages];
      const unprocessedMessages = newArr.filter(
        (id) => !processedMessagesRef.current.has(id)
      );
      if (unprocessedMessages.length > 0) {
        const unseenMessagesUpdate = unseenMessagesList.map((msg) =>
          sentMessages.includes(msg.id)
            ? {
                ...msg,
                status: "DELIVERED",
              }
            : msg
        );
        dispatch(setUnseenMessages(unseenMessagesUpdate));
        sendMsgRead(unprocessedMessages);
        newArr = [];
        unprocessedMessages.forEach((id) =>
          processedMessagesRef.current.add(id)
        );
      }
    }
  };

  const tabs = [
    {
      id: 1,
      name: "Chats",
      numberOfUsers: 0,
    },
    {
      id: 2,
      name: "Invites",
      numberOfUsers:
        pendingUsers && pendingUsers.length ? pendingUsers.length : 0,
    },
  ];
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index) => {
    setSelectedIndex(index);
  };
  const currentUserProfile =
    localStorage.getItem("profile") && localStorage.getItem("profile");
  const currentUserName =
    localStorage.getItem("User") && localStorage.getItem("User");
  return (
    <div className="chat-app">
    <ModalVideo module="Chat" autoOpen={true} />
      {showToaster && (
        <Toast
          message={
            toasterMessage ? toasterMessage : "This is a toast notification!"
          }
          onClose={() => dispatch(setShowToaster(true))}
        />
      )}
      <div className="user-list">
        <div className="chat-button-container">
          {currentUserProfile ? (
            <div style={{ position: "relative", borderRadius: "50%" }}>
              {/* <img
                src={currentUserProfile}
                height={"48px"}
                width={"48px"}
                alt={"new"}
                style={{ borderRadius: "50%" }}
              /> */}
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  border: "2px solid #09A84D",
                  padding: "4px",
                  backgroundImage: `url('${
                    currentUserProfile && currentUserProfile
                  }')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
              {isUserOnline && <div className="profile-status-tip"></div>}
            </div>
          ) : (
            <div style={{ position: "relative" }}>
              <div className="contact-chat-logo">
                {currentUserName
                  ? currentUserName
                      .split(" ")
                      .map((part) => part[0])
                      .join("")
                  : "N/A"}
              </div>
              {isUserOnline && <div className="profile-status-tip"></div>}
            </div>
          )}{" "}
          <div
            className="add-chat-button-container"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setOpenInviteModal(true);
            }}
          >
            <div className="add-chat-button">
              <img
                src={addIcon}
                width={12}
                height={12}
                style={{ width: "10px", height: "10px" }}
                alt="addicon"
              ></img>
            </div>
            <span className="add-chat-button-text" style={{display:"flex", alignItems:"baseline", gap:"2px"}}>Invite User <ToolTipCreator name={"invite_user"} /></span>
          </div>
        </div>
        <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
          <input
            className="search-user-chat"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (!searchQuery && inputValue.startsWith(" ")) {
                return;
              }
              setSearchQuery(inputValue);
            }}
            // onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="chat-tabSection">
          {tabs.map((tab, index) => (
            <div style={{ position: "relative", padding: "8px" }}>
              <button
                key={index}
                className={
                  selectedIndex === index
                    ? "chat-tab-buttons-active"
                    : "chat-tab-buttons"
                }
                onClick={() => {
                  setSelectedIndex(index);
                }}
              >
                {tab.name}
              </button>
              {tab.numberOfUsers > 0 && (
                <div className="profile-status-connectuser">
                  {tab.numberOfUsers}
                </div>
              )}
            </div>
          ))}
          <ToolTipCreator name={"chat_invite_tabs"} />
        </div>{" "}
        {selectedIndex === 0 ? (
          <div className="user-chat-list">
            {conversationloading && users.length === 0 && <ChatUserSkeleton />}
            {filteredChats &&
              filteredChats
                .filter((user) => user.invitationStatus === "ACCEPTED")
                .map((user) => (
                  <div
                    key={user.id}
                    className={`user-item ${
                      selectedUser && selectedUser.id === user.id
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      handleChatClick(user);
                    }}
                  >
                    {user.image ? (
                      <div
                        style={{ position: "relative", borderRadius: "50%" }}
                      >
                        {/*<img
                          src={user.image}
                          height={"48px"}
                          width={"48px"}
                          alt={"new"}
                          style={{ borderRadius: "50%" }}
                        /> */}
                        <div
                          style={{
                            width: "48px",
                            height: "48px",
                            borderRadius: "50%",
                            backgroundImage: `url('${user.image}')`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div>
                        {onlineUsers &&
                          onlineUsers.includes(
                            user.userOnlineId && user.userOnlineId
                          ) && <div className="profile-status-tip"></div>}
                      </div>
                    ) : (
                      <div style={{ position: "relative" }}>
                        <div className="contact-chat-logo">
                          {user.name
                            ? user.name
                                .split(" ")
                                .map((part) => part[0])
                                .join("")
                            : "N/A"}
                        </div>
                        {onlineUsers &&
                          onlineUsers.includes(user.userOnlineId) && (
                            <div className="profile-status-tip"></div>
                          )}
                      </div>
                    )}{" "}
                    <div className="chat-list-last-seen">
                      <div className="user-last-message-container">
                        <span className="contact-chat-name">{user.name}</span>
                        <span
                          className="contact-chat-name"
                          style={{
                            color: "#00000073",
                          }}
                        >
                          {/*(user.chatHistories && user.chatHistories[0]) ||
                          latestConversation
                            ? latestConversation &&
                              latestConversation.id === user.id &&
                              latestConversation.message
                              ? latestConversation.message.substring(0, 15)
                              : user.chatHistories[0] &&
                                user.chatHistories[0].message
                              ? user.chatHistories[0].message.substring(0, 15)
                              : "Type message".substring(0, 15)
                            : "Type message".substring(0, 15)*/}
                          {/*
                              ((user.chatHistories && user.chatHistories[0]) || latestConversation && latestConversation.length > 0)
                                ? latestConversation && latestConversation.find((conv) => conv.id === user.id)
                                  ? latestConversation
                                      .find((conv) => conv.id === user.id)
                                      .message.substring(0, 15)
                                  : user.chatHistories && user.chatHistories[0] && user.chatHistories[0].message
                                  ? user.chatHistories[0].message.substring(0, 15)
                                  : "Type message".substring(0, 15)
                                : "Type message".substring(0, 15)
                            */}
                          {(user.chatHistories && user.chatHistories[0]) ||
                          (latestConversation && latestConversation.length > 0)
                            ? (() => {
                                // Get all matching conversations

                                const matchingConversations =
                                  latestConversation &&
                                  latestConversation.filter(
                                    (conv) => conv.conversationId === user.id
                                  );
                                // Find the latest matching conversation
                                const latestMatchingConv =
                                  matchingConversations &&
                                  matchingConversations.sort(
                                    (a, b) =>
                                      new Date(b.updatedAt) -
                                      new Date(a.updatedAt) // Assuming `timestamp` exists
                                  )[0];
                                if (
                                  latestMatchingConv &&
                                  latestMatchingConv.message &&
                                  latestMatchingConv.message
                                ) {
                                  // Show the message from the latest matching conversation
                                  return truncateMessage(latestMatchingConv.message);
                                } else if (
                                  user.chatHistories &&
                                  user.chatHistories[0] &&
                                  user.chatHistories[0].message &&
                                  user.chatHistories[0].message
                                ) {
                                  // Show the latest message from chatHistories
                                  return truncateMessage(user.chatHistories[0].message);
                                } else {
                                  // Default message
                                  return "Invite Accepted".substring(0, 16);
                                }
                              })()
                            : "Invite Accepted".substring(0, 16)}
                        </span>
                      </div>
                      <div
                        className="user-last-message-container"
                        style={{ alignItems: "flex-end" }}
                      >
                        {user &&
                          (user.userLastSeen ||
                            (user.chatHistories && user.chatHistories[0]) ||
                            user.updatedAt) && (
                            <span
                              className="contact-chat-name"
                              style={{ color: "#000000A6", fontSize: "0.8rem" }}
                            >
                              {moment(
                                messagesTime &&
                                  messagesTime.some(
                                    (message) =>
                                      message.conversationId === user.id
                                  )
                                  ? messagesTime.find(
                                      (message) =>
                                        message.conversationId === user.id
                                    ).updatedAt
                                  : (user.chatHistories &&
                                      user.chatHistories[0] &&
                                      user.chatHistories[0].createdAt) ||
                                      user.createdAt ||
                                      user.userLastSeen
                              ).format("hh:mm A")}
                            </span>
                          )}
                        {(!selectedUser || selectedUser.id !== user.id) &&
                          getTotalUnreadMessages(user) > 0 && (
                            <div className="chat-status-connectuser-message">
                              {getTotalUnreadMessages(user)}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                ))}
          </div>
        ) : (
          <ChatInviteAccept
            handleAcceptInvite={handleAcceptInvite}
            handleDeclineInvite={handleDeclineInvite}
            handleCancelInvite={handleCancelInvite}
            users={pendingUsers && pendingUsers}
            currentUser={currentUser && currentUser}
          />
        )}
      </div>
      <div className="chat-window">
        {selectedIndex === 0 && selectedUser ? (
          <React.Fragment>
            <div className="chat-header">
              {selectedUser.image ? (
                <div style={{ position: "relative", borderRadius: "50%" }}>
                  {/*<img
                    src={selectedUser.image}
                    height={"48px"}
                    width={"48px"}
                    alt={"new"}
                    style={{ borderRadius: "50%" }}
                  /> */}
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      backgroundImage: `url('${selectedUser.image}')`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>
                  {selectedUser &&
                    onlineUsers &&
                    onlineUsers.includes(selectedUser.userOnlineId) && (
                      <div className="profile-status-tip"></div>
                    )}
                </div>
              ) : (
                <div style={{ position: "relative" }}>
                  <div className="contact-chat-logo">
                    {selectedUser.name
                      ? selectedUser.name
                          .split(" ")
                          .map((part) => part[0])
                          .join("")
                      : "N/A"}
                  </div>
                  {selectedUser &&
                    onlineUsers &&
                    onlineUsers.includes(selectedUser.userOnlineId) && (
                      <div className="profile-status-tip"></div>
                    )}
                </div>
              )}{" "}
              <div className="chat-header-download-conatiner">
                <div className="contact-chat-conatiner">
                  <span className="contact-chat-name" style={{display:"flex",alignItems:"center", gap:"3px"}}>
                    {" "}
                    {selectedUser.name} <ToolTipCreator name={"read_receipt"} />
                  </span>
                  <span className="last-seen">
                    {/*selectedUser &&
                  onlineUsers &&
                  onlineUsers.includes(selectedUser.senderId)
                    ? "Online"
                    : "Last Seen " +
                      moment(selectedUser.updatedAt).format("hh:mm A") */}
                    {selectedUser &&
                    onlineUsers &&
                    onlineUsers.includes(selectedUser.userOnlineId)
                      ? typingUsers &&
                        typingUsers.some(
                          (user) =>
                            user.id === selectedUser.id &&
                            currentUser.id !== user.userId
                        )
                        ? "Typing..."
                        : "Online"
                      : typingUsers &&
                        typingUsers.some(
                          (user) =>
                            user.id === selectedUser.id &&
                            currentUser.id !== user.userId
                        )
                      ? "Typing..."
                      : "Last Seen " +
                        moment(
                          (users &&
                            users.length > 0 &&
                            users.find((user) => user.id === selectedUser.id)
                              .userLastSeen) ||
                            selectedUser.userLastSeen ||
                            selectedUser.updatedAt
                        ).format("hh:mm A")}
                  </span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div className="chat-download-button" onClick={()=>{
                  setShowDownloadModal(true);
                }}>
                  {" "}
                  <img src={downloadIcon} height={24} width={24} alt="icon" />
                  Download Chat 
                </div> <ToolTipCreator name={"download_chat"} />
                </div>
              </div>
            </div>
            <div className="chat-messages" ref={chatMessagesRef}>
              {selectedUser.invite !== "pending" ? (
                <React.Fragment>
                  {chatWindowLoading && <ChatWindowSkeleton />}
                  {messages &&
                    messages
                      .filter((msg) => msg.conversationId === selectedUser.id)
                      .map((msg, idx) => {
                        // if (msg.status === "DELIVERED") {
                        //   console.log("here in send reeadd");
                        //   sendMsgRead([msg.id]);
                        // }
                        return (
                          <div className="chat-reciever">
                            {msg.senderId !== currentUser.id && (
                              <React.Fragment>
                                {selectedUser.image ? (
                                  <div
                                    style={{
                                      position: "relative",
                                      borderRadius: "50%",
                                    }}
                                  >
                                    {/*<img
                                      src={selectedUser.image || profileIcon}
                                      height={"48px"}
                                      width={"48px"}
                                      alt={"new"}
                                      style={{ borderRadius: "50%" }}
                                    /> */}
                                    <div
                                      style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "50%",
                                        backgroundImage: `url('${selectedUser.image}')`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                      }}
                                    ></div>
                                    {selectedUser &&
                                      onlineUsers &&
                                      onlineUsers.includes(
                                        selectedUser.userOnlineId
                                      ) && (
                                        <div className="profile-status-tip"></div>
                                      )}
                                  </div>
                                ) : (
                                  <div style={{ position: "relative" }}>
                                    <div className="contact-chat-logo">
                                      {selectedUser.name
                                        ? selectedUser.name
                                            .split(" ")
                                            .map((part) => part[0])
                                            .join("")
                                        : "N/A"}
                                    </div>
                                    {selectedUser &&
                                      onlineUsers &&
                                      onlineUsers.includes(
                                        selectedUser.userOnlineId
                                      ) && (
                                        <div className="profile-status-tip"></div>
                                      )}
                                  </div>
                                )}{" "}
                              </React.Fragment>
                            )}
                            <div
                              className={
                                msg.senderId === currentUser.id
                                  ? "message-sender sender-msg-box"
                                  : ""
                              }
                              style={{ maxWidth: "70%" }}
                            >
                              {msg.senderId === currentUser.id && (
                                <React.Fragment>
                                  {currentUserProfile ? (
                                    <div
                                      style={{
                                        position: "relative",
                                        borderRadius: "50%",
                                      }}
                                    >
                                      {/*<img
                                        src={currentUserProfile}
                                        height={"24px"}
                                        width={"24px"}
                                        alt={"new"}
                                        style={{ borderRadius: "50%" }}
                                      /> */}
                                      <div
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          borderRadius: "50%",
                                          backgroundImage: `url('${currentUserProfile}')`,
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                          backgroundRepeat: "no-repeat",
                                        }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div style={{ position: "relative" }}>
                                      <div
                                        className="contact-chat-logo"
                                        style={{
                                          height: "24px",
                                          width: "24px",
                                        }}
                                      >
                                        {currentUserName
                                          ? currentUserName
                                              .split(" ")
                                              .map((part) => part[0])
                                              .join("")
                                          : "N/A"}
                                      </div>
                                    </div>
                                  )}{" "}
                                </React.Fragment>
                              )}
                              <div
                                key={idx}
                                className={`message ${
                                  msg.senderId === currentUser.id
                                    ? "sent"
                                    : "received"
                                }`}
                                style={{
                                  opacity:
                                    sendLoading &&
                                    msg.senderId === currentUser.id &&
                                    idx === messages.length - 1
                                      ? 0.5
                                      : 1,
                                  filter:
                                    sendLoading &&
                                    msg.senderId === currentUser.id &&
                                    idx === messages.length - 1
                                      ? "blur(1px)"
                                      : "none",
                                }}
                              >
                                <div className="last-msg-loading">
                                  {highlightFlaggedWords(msg.message)}{" "}
                                  {sendLoading &&
                                    msg.senderId === currentUser.id &&
                                    idx === messages.length - 1 && (
                                      <Spin
                                        indicator={
                                          <Icon
                                            type="loading"
                                            style={{ fontSize: 18 }}
                                            spin
                                          />
                                        }
                                      />
                                    )}
                                </div>
                               <span className="chat-time">
                                  <span className="chat-date">
                                    {moment(msg.sentTime || msg.updatedAt || new Date()).format("MM/DD/YYYY")}
                                  </span>{" "}
                                  <span className="chat-clock">
                                    {moment(msg.sentTime || msg.updatedAt || new Date()).format("hh:mm A")}
                                  </span>
                                </span>
                                {msg.senderId === currentUser.id && (
                                  <span className="message-status">
                                    {msg.status === "SENT" ? (
                                      <span>✔</span>
                                    ) : msg.status === "DELIVERED" ? (
                                      <span className="double-tick-icon">
                                        ✔✔
                                      </span>
                                    ) : msg.status === "READ" ? (
                                      <span className="double-tick-icon read">
                                        ✔✔
                                      </span>
                                    ) : null}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  {/*sendLoading && (
                    <div style={{ textAlign: "center" }}>
                      <Spin />
                    </div>
                  )*/}
                </React.Fragment>
              ) : (
                <div className="no-chat-pending-invite">
                  <img src={lockIcon} alt="logo" width={120} />
                  <span className="no-chat-text">
                    User has not accepted Invite Yet
                  </span>
                </div>
              )}
            </div>
            {selectedUser.invite !== "pending" && (
              <div className="chat-input">
                <input
                  type="text"
                  placeholder="Type your message here.."
                  value={messageText}
                  onFocus={() => {
                    sendReadEvent();
                  }}
                  onChange={(e) => {
                    setMessageText(e.target.value);
                    if (!typingSent.current) {
                      sendUserTypingEvent();
                      typingSent.current = true;
                    }

                    if (typingTimeout.current) {
                      clearTimeout(typingTimeout.current);
                    }

                    typingTimeout.current = setTimeout(() => {
                      stopUserTyping();
                      typingSent.current = false;
                    }, 2000);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      sendMessage();
                    }
                  }}
                />
                <ToolTipCreator name={"type_your_message_here"} />
                <button
                  className="chat-input-button"
                  onClick={() => {
                    sendMessage();
                  }}
                >
                  <img
                    src={sendIcon}
                    height={"24px"}
                    width={"24px"}
                    alt={"new"}
                  />
                </button>
              </div>
            )}
          </React.Fragment>
        ) : (
          <div className="no-chat">
            <img src={logo} alt="logo" />
            <span className="no-chat-text">Select a user to chat with</span>
          </div>
        )}
      </div>
      {openInviteModal && (
        <InviteChatModal
          open={openInviteModal}
          handleClose={handleCloseInviteModal}
          userList={userList && userList}
          handleInvite={handleInvite}
        />
      )}
      {showDownloadModal && 
        <ChatDownloadModal
          showDownloadModal={showDownloadModal}
          setShowDownloadModal={setShowDownloadModal}
          selectedUser={selectedUser && selectedUser}
        />
      }
      <NewLoader isLoading={loading} />
    </div>
  );
};
